<script setup>
import { ref, defineAsyncComponent } from 'vue'
import { Icon } from '@iconify/vue'
import { useRouter } from 'vue-router'
import { useChannelsStore } from '@/stores/channels'
import { maintainerData } from '@/composables/useLayouts'

import AlertPrice from '@/views/dash/channels/Pages/AlertPrice.vue'
import InputFormHorizontal from '@/components/UI/Form/InputFormHorizontal.vue'
import Checkbox from 'primevue/checkbox';

const TabUserDepartment = defineAsyncComponent(() => import('@/components/tabs/TabUserDepartment.vue'))
const ChatTransition = defineAsyncComponent(() => import('@/components/utils/ChatTransition.vue'))
const Toggle = defineAsyncComponent(() => import('@/components/UI/Toogle/ToogleWithDescription.vue'))

const store = useChannelsStore()
const router = useRouter()

const authorizationAttendance = ref('')
const ignoreMessages = ref('')
const sipEnabled = ref(false)

store.channel.type = store.channel.type || 'whatsapp'
store.channel.server_type = store.channel.server_type || 'dialog360'

// Inicializar o objeto more se não existir
if (!store.channel.more) {
    store.channel.more = {}
}

if (store.channel?.start_service) {
    authorizationAttendance.value = 'true'
}

if (store.channel?.more?.sip_enabled !== undefined) {
    sipEnabled.value = store.channel.more.sip_enabled
}

if (store.channel?.more?.ignore_messages === undefined) {
    store.channel.more.ignore_messages = false
}
if (store.channel?.more?.ignore_messages) {
    ignoreMessages.value = 'true'
}

const registerChannel360 = () => {
    const partnerToken = maintainerData.value?.dialog360_partner

    if (!partnerToken) {
        console.log('[CHAT] Não foi possível encontrar o token do parceiro da 360 Dialog')
        return
    }

    const redirectTo = `${window.location.origin}/v2/canais/cadastrar/whatsapp/360dialog-on-promise`
    const windowFeatures = 'toolbar=no, menubar=no, width=600, height=900, top=100, left=100'
    const endpointPermission = `https://hub.360dialog.com/dashboard/app/${partnerToken}/permissions?redirect_url=${redirectTo}`
    window.open(endpointPermission, 'integratedOnboardingWindow', windowFeatures)

    setTimeout(() => router.push({ name: 'channels.home' }), 5000)
}

function handleToggleAuthorization(value) {
    authorizationAttendance.value = value
    store.channel.start_service = null
}

function handleToggleSipEnabled(value) {
    if (!store.channel.more) {
        store.channel.more = {}
    }
    store.channel.more.sip_enabled = value
}

function handleToggleIgnoreMessages(value) {
    store.channel.more.ignore_messages = value === 'true'
}
</script>

<template>
    <template v-if="store.formStep === 2">
        <div class="space-y-4">
            <InputFormHorizontal v-if="store.channel?.id" v-model="store.channel.name" :init-value="store.channel.name"
                :block-edit="store.loading" label="Nome do canal"
                placeholder="Como você irá identificar o canal pelo sistema?" rules="required" vertical />

            <InputFormHorizontal v-if="store.channel?.id" :init-value="store.channel.user" :block-edit="true"
                label="Número do WhatsApp"
                hint="Ao cadastrar o canal, o número é vinculado automaticamente. Não é possível alterá-lo!" vertical />
            <Toggle v-model="authorizationAttendance" t-label="Autorização de inicio de atendimento"
                t-description="Ao habilitar essa função é possivel relacionar um usuario ou um departamento para iniciar um atendimento"
                @update:model-value="handleToggleAuthorization" />


            <Toggle v-model="ignoreMessages" t-label="Ignorar todas as mensagens?"
                @update:model-value="handleToggleIgnoreMessages"
                t-description="Ativando essa opção, o sistema irá ignorar todas as mensagens recebidas!" />

            <div v-if="store.channel?.more" class="flex items-center gap-2">
                <Checkbox v-model="sipEnabled" :binary="true" inputId="sip_enabled"
                    @update:model-value="handleToggleSipEnabled" />
                <label for="sip_enabled" class="cursor-pointer">
                    Habilitar SIP
                </label>
            </div>
            <ChatTransition :show="authorizationAttendance === 'true'" custom-class="form_group">
                <TabUserDepartment v-model="store.channel.start_service" />
            </ChatTransition>
            <button v-if="!store.channel?.id"
                class="flex justify-center items-center bg-pink-500 hover:bg-pink-600 text-white text-sm font-bold py-2 px-4 rounded-full chat_transition"
                :class="{ 'opacity-50 cursor-not-allowed': false }" @click.prevent.stop="registerChannel360()">
                <Icon icon="simple-icons:whatsapp" class="text-white h-4 w-4 mr-2" />
                Cadastrar/Vincular número da 360 Dialog
            </button>

            <AlertPrice />
        </div>
    </template>

    <template v-else-if="store.formStep === 1">
        Instruções de cadastro
    </template>
</template>
